/** Welcome hub background image (root public asset, not under /images). */
export const WELCOME_BACKGROUND_PATH = '/welcome.jpg';

/** Painted panel for tutorial / campaign / strategy modal dialogs. */
export const WELCOME_PANEL_BACKGROUND_PATH = '/images/blue_rectangle_large.png';

/** Painted frame for Welcome hub info carousel boxes only. */
export const WELCOME_INFO_PANEL_BACKGROUND_PATH = '/images/welcome_frame.png';

/** Painted navigation control on Welcome hub (Prepare Strategy, etc.). */
export const WELCOME_MENU_BUTTON_PATH = '/images/gold1.png';

/** Painted navigation control on Lore section tabs. */
export const LORE_NAV_BUTTON_PATH = '/images/blue_button3.png';

/** Painted Explore CTA on Explore Unknown portal screen. */
export const EXPLORE_UNKNOWN_EXPLORE_BUTTON_PATH = '/images/blue_button3.png';

/** Full-screen portal backdrop on Explore Unknown entry (before scanner / map). */
export const EXPLORE_UNKNOWN_PORTAL_BACKGROUND_PATH = '/images/explore_unknown_background.jpg';

/** Painted back control shared by menu screens. */
export const MENU_BACK_BUTTON_PATH = '/images/gray_button2.png';

/** Painted rename control on Profile. */
export const PROFILE_RENAME_BUTTON_PATH = '/images/green_button4.png';

/** Painted send control on Black Ops mission cards. */
export const BLACK_OPS_SEND_BUTTON_PATH = '/images/green_button3.png';

/** Painted complete control on Black Ops mission cards (same asset, golden tint). */
export const BLACK_OPS_COMPLETE_BUTTON_PATH = '/images/green_button3.png';

/** Golden tint for Black Ops complete buttons. */
export const BLACK_OPS_COMPLETE_BUTTON_SURFACE_FILTER = 'hue-rotate(-78deg) saturate(1.5) brightness(1.05) contrast(1.06)';

/** Painted reset control on Black Ops operatives panel. */
export const BLACK_OPS_RESET_BUTTON_PATH = '/images/red_button4.png';

/** Painted save/load controls on Black Ops operatives panel. */
export const BLACK_OPS_COMPOSITION_BUTTON_PATH = '/images/blue_button1.png';

/** Painted end-turn control on Battle UI. */
export const BATTLE_UI_END_TURN_BUTTON_PATH = '/images/gray_button2.png';

/** Black tint for battle strategy / completed orders modal panels (blue_rectangle_large). */
export const BATTLE_MODAL_PANEL_SURFACE_FILTER = 'saturate(0) brightness(0.26) contrast(1.1)';

/** Strategy / completed orders modal overlay — above EU kangaroo (15080), below targeting UI (100004). */
export const BATTLE_STRATEGY_MODAL_Z_INDEX = 15090;

/** Painted resign control on Battle UI. */
export const BATTLE_UI_RESIGN_BUTTON_PATH = '/images/red_button4.png';

/** Borderless painted panel for resign confirmation dialog. */
export const RESIGN_DIALOG_BACKGROUND_PATH = '/images/update_dialog.png';

/** Dark gray tint for Explore Unknown map mission stats panel (update_dialog). */
export const EXPLORE_UNKNOWN_MISSION_PANEL_SURFACE_FILTER = 'saturate(0) brightness(0.48) contrast(1.08)';

/** Painted confirm control on resign dialog. */
export const RESIGN_DIALOG_CONFIRM_BUTTON_PATH = '/images/red_button3.png';

/** Painted cancel control on resign dialog. */
export const RESIGN_DIALOG_CANCEL_BUTTON_PATH = '/images/gray_button5.png';

/** Painted bar behind Battle UI select-target / cancel-targeting prompt. */
export const BATTLE_UI_TARGETING_BAR_BACKGROUND_PATH = '/images/blue_rectangle_long.png';

/** Painted battle log open control (green asset, black tint). */
export const BATTLE_ACTION_LOG_BUTTON_PATH = '/images/green_button4.png';

/** Painted emote row control on Battle UI (neutral tone). */
export const BATTLE_UI_EMOTE_BUTTON_PATH = '/images/blue_button1.png';

/** Painted emote row control — positive tone (greet, thanks, etc.). */
export const BATTLE_UI_EMOTE_POSITIVE_BUTTON_PATH = '/images/green_button3.png';

/** Painted emote row control — negative tone (taunt, wake up, etc.). */
export const BATTLE_UI_EMOTE_NEGATIVE_BUTTON_PATH = '/images/red_button3.png';

/** Emote picker painted buttons — preload together on BattleUI mount. */
export const BATTLE_UI_EMOTE_BUTTON_PRELOAD_PATHS = [
  BATTLE_UI_EMOTE_BUTTON_PATH,
  BATTLE_UI_EMOTE_POSITIVE_BUTTON_PATH,
  BATTLE_UI_EMOTE_NEGATIVE_BUTTON_PATH,
];

/** Painted Strike! control on counter strike dialog. */
export const COUNTER_STRIKE_STRIKE_BUTTON_PATH = '/images/red_button4.png';

/** Painted Keep control on counter strike dialog. */
export const COUNTER_STRIKE_KEEP_BUTTON_PATH = '/images/green_button3.png';

/** Black tint for battle log open button. */
export const BATTLE_ACTION_LOG_BUTTON_SURFACE_FILTER = 'saturate(0) brightness(0.3) contrast(1.1)';

/** Painted ranking tab control on Honor Hall. */
export const HONOR_HALL_TAB_BUTTON_PATH = '/images/blue_button1.png';

/** Painted primary CTA on After Battle (green asset, golden tint). */
export const AFTER_BATTLE_GOLDEN_BUTTON_PATH = '/images/green_button4.png';

/** Golden tint for After Battle primary CTAs (green_button4 → #ffd700 gold, not orange). */
export const AFTER_BATTLE_GOLDEN_BUTTON_SURFACE_FILTER = 'hue-rotate(-58deg) saturate(1.28) brightness(1.14) contrast(1.03)';

/** Painted secondary CTA on After Battle. */
export const AFTER_BATTLE_WHITE_BUTTON_PATH = '/images/gray_button5.png';

/** Painted navigation CTA on After Battle. */
export const AFTER_BATTLE_BLUE_BUTTON_PATH = '/images/blue_button1.png';

/** Painted subscribe CTA on After Battle loss panel. */
export const AFTER_BATTLE_GREEN_BUTTON_PATH = '/images/green_button4.png';

/** Painted Refresh control on War Effort FFA open-games list. */
export const WAR_EFFORT_REFRESH_BUTTON_PATH = '/images/gray_button5.png';

/** Painted faction selection control on War Effort purpose setup. */
export const WAR_EFFORT_FACTION_BUTTON_PATH = '/images/blue_button1.png';

/** Painted primary CTA on War Effort purpose setup (create / ready / skeleton crew). */
export const WAR_EFFORT_PRIMARY_BUTTON_PATH = '/images/green_button4.png';

/** Painted Add Bot control on War Effort FFA lobby slots. */
export const WAR_EFFORT_ADD_BOT_BUTTON_PATH = '/images/green_button3.png';

/** Painted Remove Bot control on War Effort FFA lobby slots. */
export const WAR_EFFORT_REMOVE_BOT_BUTTON_PATH = '/images/red_button4.png';

/** Painted Leave Mission control on War Effort. */
export const WAR_EFFORT_LEAVE_MISSION_BUTTON_PATH = '/images/red_button4.png';

/** Full-screen backdrop on War Effort purpose setup (start / FFA lobby). */
export const WAR_EFFORT_PURPOSE_SETUP_BACKGROUND_PATH = '/images/wareffort.jpg';

/** Weathered terminal tint for painted blue menu surfaces. */
export const MENU_PAINTED_SURFACE_FILTER = 'saturate(0.72) brightness(0.88) contrast(1.06)';

/** Burnt-orange tint for Lore section nav buttons (matches parchment / saddle-brown theme). */
export const LORE_NAV_BUTTON_SURFACE_FILTER = 'hue-rotate(-175deg) saturate(1.2) brightness(0.72) contrast(1.08)';

/** Brand mark for boot splash and auth. */
export const BOOT_LOGO_PATH = '/images/logo.png';

/**
 * Static images for hub menus (Welcome, Battle Overview, Strategy shell, etc.).
 * Preloaded at app boot so painted panels/buttons/backgrounds appear together.
 */
export const HUB_MENU_PRELOAD_IMAGE_PATHS = Object.freeze([
  BOOT_LOGO_PATH,
  WELCOME_BACKGROUND_PATH,
  WELCOME_PANEL_BACKGROUND_PATH,
  WELCOME_INFO_PANEL_BACKGROUND_PATH,
  WELCOME_MENU_BUTTON_PATH,
  MENU_BACK_BUTTON_PATH,
  '/factions/remnants.png',
  '/images/black_paint.jpg',
  '/images/profile.jpg',
  '/images/billy_buck_bank.jpg',
  '/images/lore.jpg',
  '/images/honorhall.png',
  '/images/battleoverview.jpg',
  '/images/pvp.jpg',
  '/images/pve.jpg',
  '/images/rejoin.jpg',
  '/images/blackops.jpg',
  '/images/wareffort.jpg',
  '/images/sp.jpg',
  '/images/280.jpg',
  '/images/tournament.jpg',
  '/images/dispatch_asset_bg.jpg',
  '/images/blackops_erray.jpg',
  '/images/blackops_bg.jpg',
  EXPLORE_UNKNOWN_PORTAL_BACKGROUND_PATH,
]);
